export function calculateAge(date: any): number | null {
    if (!date) {
        return null;
    }

    const raw =
        date instanceof Date
            ? date
            : date.value instanceof Date
            ? date.value
            : typeof date === 'string'
            ? new Date(date)
            : date.value
            ? new Date(date.value)
            : null;

    if (!raw || isNaN(raw.getTime())) {
        return null;
    }

    const today = new Date();
    let age = today.getFullYear() - raw.getFullYear();
    const monthDiff = today.getMonth() - raw.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < raw.getDate())) {
        age--;
    }

    return age;
}
